/* Product page adapter: variant selection and RU0010 unit toggle. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var formatString = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    var token = match ? match[1] : 'amount';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }

    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ' ');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return formatString.replace(placeholder, value);
  }

  function optionAt(variant, index) {
    return variant['option' + (index + 1)];
  }

  function matches(variant, selection) {
    for (var i = 0; i < selection.length; i++) {
      if (selection[i] == null || selection[i] === '') continue;
      if (optionAt(variant, i) !== selection[i]) return false;
    }
    return true;
  }

  function findVariant(variants, selection) {
    for (var i = 0; i < variants.length; i++) {
      if (matches(variants[i], selection)) return variants[i];
    }
    return null;
  }

  function init(root) {
    var dataNode = root.querySelector('[data-product-variants]');
    if (!dataNode) return;

    var variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }
    if (!variants || !variants.length) return;

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var addLabel = root.getAttribute('data-add-label') || 'Add to cart';
    var soldLabel = root.getAttribute('data-sold-label') || 'Sold out';
    var input = root.querySelector('[data-variant-input]');
    var priceEl = root.querySelector('[data-product-price]');
    var addButton = root.querySelector('[data-add-button]');
    var status = root.querySelector('[data-variant-status]');
    var selection = [];

    root.querySelectorAll('[data-option-value][aria-checked="true"]').forEach(function (el) {
      selection[Number(el.getAttribute('data-option-index'))] = el.getAttribute('data-option-value');
    });

    function setUnit(unit) {
      var guide = root.querySelector('[data-fit-guide]');
      if (!guide) return;
      var useCm = unit === 'cm';
      guide.querySelectorAll('[data-cm]').forEach(function (cell) {
        var text = cell.getAttribute(useCm ? 'data-cm' : 'data-in');
        if (text) cell.textContent = text;
      });
      guide.querySelectorAll('[data-unit-suffix]').forEach(function (el) {
        el.textContent = useCm ? 'cm' : 'in';
      });
      guide.querySelectorAll('[data-unit-toggle]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-unit-toggle') === unit ? 'true' : 'false');
      });
      var unitStatus = guide.querySelector('[data-unit-status]');
      if (unitStatus) unitStatus.textContent = useCm ? 'Showing centimeters' : 'Showing inches';
    }

    function applyVariant(variant, announce) {
      if (!variant) return;
      selection = [variant.option1, variant.option2, variant.option3];
      if (input) input.value = String(variant.id);

      root.querySelectorAll('[data-option-value]').forEach(function (el) {
        var index = Number(el.getAttribute('data-option-index'));
        var value = el.getAttribute('data-option-value');
        var checked = selection[index] === value;
        el.setAttribute('aria-checked', checked ? 'true' : 'false');
        el.tabIndex = checked ? 0 : -1;

        var trial = selection.slice();
        trial[index] = value;
        var match = findVariant(variants, trial);
        var unavailable = !match || !match.available;
        el.classList.toggle('is-unavailable', unavailable);
        var label = el.getAttribute('data-label') || value;
        el.setAttribute('aria-label', unavailable ? label + ', sold out' : label);
      });

      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? addLabel : soldLabel;
      }

      var img = root.querySelector('[data-product-image]');
      if (img && variant.image && img.getAttribute('src') !== variant.image) {
        img.src = variant.image;
        img.srcset = variant.image + ' 800w';
        if (variant.imageAlt) img.alt = variant.imageAlt;
      }

      if (announce && status) {
        var names = [];
        root.querySelectorAll('[data-option-value][aria-checked="true"]').forEach(function (el) {
          names.push(el.getAttribute('data-label') || el.textContent.trim());
        });
        names.push(formatMoney(variant.price, moneyFormat));
        names.push(variant.available ? 'In stock' : 'Sold out');
        status.textContent = names.join(', ');
      }
    }

    var initial = findVariant(variants, selection);
    if (initial) applyVariant(initial, false);

    root.addEventListener('click', function (event) {
      var unitBtn = event.target.closest('[data-unit-toggle]');
      if (unitBtn && root.contains(unitBtn)) {
        setUnit(unitBtn.getAttribute('data-unit-toggle'));
        return;
      }

      var choice = event.target.closest('[data-option-value]');
      if (!choice || !root.contains(choice)) return;

      var index = Number(choice.getAttribute('data-option-index'));
      var value = choice.getAttribute('data-option-value');
      var next = selection.slice();
      next[index] = value;
      var variant = findVariant(variants, next);
      if (!variant) {
        for (var i = 0; i < variants.length; i++) {
          if (optionAt(variants[i], index) === value) {
            variant = variants[i];
            break;
          }
        }
      }
      if (variant) applyVariant(variant, true);
    });

    root.addEventListener('keydown', function (event) {
      var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
      if (keys.indexOf(event.key) === -1) return;
      var choice = event.target.closest('[data-option-value]');
      if (!choice || !root.contains(choice)) return;
      var group = choice.closest('[role="radiogroup"]');
      if (!group) return;
      var radios = Array.prototype.slice.call(group.querySelectorAll('[data-option-value]'));
      var current = radios.indexOf(choice);
      if (current < 0) return;
      var nextIndex = current;
      if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = radios.length - 1;
      else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (current + 1) % radios.length;
      else nextIndex = (current - 1 + radios.length) % radios.length;
      event.preventDefault();
      radios[nextIndex].click();
      radios[nextIndex].focus();
    });
  }

  function boot() {
    document.querySelectorAll('[data-product-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
